<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finish_text"
                    @load="load_list"
            >
                <div class="item-panel" v-for="(item,index) in list" :key="index" @click="show_detail(item.id)">
                   <order-item :p_order="item" :p_action="p_action"/>
                </div>
                <van-empty v-if="list.length===0" description="暂无数据" />
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import OrderItem from "./OrderItem";

    export default {
        name: "OrderList",
        components: {OrderItem},
        props:{
            p_action:{
                type:String,
                default:'1',    //1梅唐四季，2耘径联盟
                required:true,
            },
            p_status:{          //状态用于筛选list
                type:Number,
                default:0,
                required:true,
            },
            p_enable_detail:{
                type:Boolean,
                default:false,
                required:false,
            }
        },
        data(){
            return{
                list:[],
                loading:false,
                finished:false,
                refreshing: false,
                load_qty:10,
                finish_text:'',
            }
        },
        methods:{
            ...mapActions([
                'GetMyOrderList',
            ]),
            show_detail(val){
                if(this.p_enable_detail){
                    let order_id=val;
                    this.$router.push({ name: 'OrderDetail',params: {order_id}});
                }
            },
            load_list(){
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                this.loading=true;
                let p={
                    show_count:this.load_qty,
                    action:this.p_action,
                    status:this.p_status,
                    uid:this.$store.getters.getLoginUser.id,
                };
                this.GetMyOrderList(p).then(res=>{
                    this.loading=false;
                    this.list=res.list;
                    if(this.list.length>10){
                        this.finish_text='我是底线';
                    }
                    if(this.load_qty>=res.total){
                        this.finished=true;
                    }else{
                        this.load_qty +=10;
                    }
                });
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                this.load_list();
            },
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            this.load_list();
        }
    }
</script>

<style scoped>

</style>